import React, { useEffect, useState } from "react";
import { Row, Col, Button, Spinner, Form, FloatingLabel } from "react-bootstrap";
import { Envelope, SkipBackwardCircle, CheckLg, BoxArrowLeft } from "react-bootstrap-icons";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { currencyFormatter } from "../../generals/normalizaInput";
import { actions as actionStep } from "../../../reducers/Step";
import { actions as actionStepOne,  getUserName } from "../../../reducers/StepOne";
import { actions as actionStepTwo, getEmail } from "../../../reducers/StepTwo";
import FAMSA from "../../../config/constants";
import axios from "axios";
import { Alert } from "../../Alerts";
import { getTypePay } from "../../../reducers/TypePayment";
import Loading from "../../Loading";
import { getLang } from '../../../reducers/lang';

const StepFour = ({ datapay }) => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const type_pay = useSelector(getTypePay);
    const [amount, setAmount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingMail, setLoadingMail] = useState(false);
    const Email = useSelector(getEmail);
    const user_name = useSelector(getUserName);
    const [validated, setValidated] = useState({
        email: null
    });
    const [invalid, setInValid] = useState({
        email: null
    });
    const sLang = useSelector(getLang);
    const url = 'https://www.famsafurniture.com'

    useEffect(() => {
        let auxamount = 0;
        datapay.map((value, index) => {
            auxamount += value.Amount;
        });
        setAmount(auxamount);
    }, []);

    const handleotherpayment = async () => {
        distpatch(actionStepOne.reset()); 
        //distpatch(actionPay.reset());
        distpatch(actionStepTwo.setTotal("0"));
        distpatch(actionStep.setPage(0));
    }

    const handEmail = (e, value) => {
        e.preventDefault();
        distpatch(actionStepTwo.setEmail(value));
    }

    const handleSendEmail = async (event) => {
        event.preventDefault();
        
        if (Email !== '') {
            setInValid({ ...invalid, email: false })
            setValidated({ ...validated, storemailis_id: true });
        } else {
            setInValid({ ...invalid, email: true })
            setValidated({ ...validated, email: false });
            return;
        }

        setLoadingMail(true);
        let auxpay = [];
        //debugger
        datapay.map((value, index) => {
            // debugger
            auxpay.push({
                AccountNo: value.AccountNo,
                ContractId: value.ContractId,
                VerificationCode: value.VerificationCode,
                DonwloadPath: value.DonwloadPath,
                TransactionId: value.TransactionId,
                Amount: value.Amount,
                Phone: value.Phone,
                Store: value.Store,
                CardType: value.CardType,
                CustomerName: value.CustomerName,
                SessionId: value.SessionId,
                Transaction: FAMSA.SERVER.TRANSACTION,
            });
        });
        const params = {
            SourceId: "",
            Company: (type_pay === 1) ? "FAMSAINC" : "LOANS",
            PaymentDetail: auxpay,
            CardInfo: {
                name: "",
                number: "",
                expiry: "",
                cvc: "",
                zipCode: ""
            },
            emailRecip: Email,
            lang: sLang
        }
        await handleEmailSent(params);
        // }
    }

    const handleEmailSent = async (params) => {
        const fullURL = FAMSA.SERVER.SERVER + `/api/SendRecipt`;
        await axios.post(fullURL, params).then((response) => {
            setLoadingMail(false);
            if (response.status === 200) {
                Alert("success", "Email sent", "The recipt has been sent to " + Email);
            } else {
                Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
            }
        }).catch(error => {
            //console.log(error);
            setLoadingMail(false);
            Alert("danger", "Error", error.response.data);
        });
    };

    const handleLinkDownloand = async (event) => {
        //event.preventDefault();
        setLoading(true);
        let auxpay = [];
        //debugger
        datapay.map((value, index) => {
            // debugger
            auxpay.push({
                AccountNo: value.AccountNo,
                ContractId: value.ContractId,
                VerificationCode: value.VerificationCode,
                DonwloadPath: value.DonwloadPath,
                TransactionId: value.TransactionId,
                Amount: value.Amount,
                Phone: value.Phone,
                Store: value.Store,
                CardType: value.CardType,
                CustomerName: value.CustomerName,
                SessionId: value.SessionId,
                Transaction: FAMSA.SERVER.TRANSACTION,
            });
        });
        const params = {
            SourceId: "",
            Company: (type_pay === 1) ? "FAMSAINC" : "LOANS",
            PaymentDetail: auxpay,
            CardInfo: {
                name: "",
                number: "",
                expiry: "",
                cvc: "",
                zipCode: ""
            },
            emailRecip: null,
            staffId: FAMSA.GUESS_USER,
            lang: sLang,
        }
        await handleDownloandLoans(params);
        // }
    }

    /*const handleDownloand = async (params) => {
        const fullURL = FAMSA.SERVER.SERVER_DOWNLOAND;
        //console.log(params);
        await axios.post(fullURL, params).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                window.open(response.data);
            } else {
                Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
            }
        }).catch(error => {
            setLoading(false);
            Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
        });
    };*/

    const handleDownloandLoans = async (params) => {
        const fullURL = FAMSA.SERVER.SERVER + `/api/GenerateRecipt`;
        await axios.post(fullURL, params).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                window.open(response.data);
            } else {
                Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
            }
        }).catch(error => {
            //console.log(error);
            setLoading(false);
            Alert("danger", "Error", error.response.data);
        });
    };

    return (
        <>
            {(datapay === null) ?
                <><Loading /></>
                :
                <>
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 3 }} sm={{ span: 3 }}></Col>
                        <Col className="mx-3 my-3" md={{ span: 8 }} sm={{ span: 8 }}>
                            <h4 className="text-decoration-underline famsa-text-blue fw-bold"><FormattedMessage id="step.four.title" /></h4>
                        </Col>
                        <Col className="famsa-bg-gray" md={{ span: 5 }} sm={{ span: 8 }}>
                            <Row className='justify-content-center my-3'>
                                <h5 className="famsa-text-blue fw-bold">{datapay[0]?.CustomerName}</h5>
                            </Row>
                            <Row className='justify-content-center'>
                                <Col className="text-start"><p className="famsa-text-gray"><FormattedMessage id="step.three.account" />:</p></Col>
                                <Col className="text-end"><p className="famsa-text-blue">{datapay[0]?.AccountNo}</p></Col>
                            </Row>
                            <Row className='justify-content-center'>
                                <Col className="text-start "><p className="famsa-text-gray"><FormattedMessage id="step.two.contract.number" />: {datapay[0]?.ContractId}</p></Col>
                                <Col className="text-end" ><p className="famsa-text-gray">{currencyFormatter({ currency: "USD", value: amount })}</p></Col>
                            </Row>
                            {(type_pay === 2) ?
                            <Row className='justify-content-center'>
                                <Col className="text-start "><p className="famsa-text-gray"><FormattedMessage id="step.three.summary.txt.convenience" /></p></Col>
                                <Col className="text-end" ><p className="famsa-text-gray">{currencyFormatter({ currency: "USD", value: parseFloat(FAMSA.SERVER.TRANSACTION) })}</p></Col>
                            </Row>
                            : null}
                            <Row className='justify-content-center'>
                                <Col className="text-start"><p className="famsa-text-gray"><FormattedMessage id="step.four.payment.type" />:</p></Col>
                                <Col className="text-end"><p className="famsa-text-blue">{datapay[0]?.CardType}</p></Col>
                            </Row>
                            <Row className='justify-content-center'>
                                <Col className="text-start"><p className="famsa-text-gray"><FormattedMessage id="step.four.authorization.code" />:</p></Col>
                                <Col className="text-end"><p className="famsa-text-blue">{datapay[0]?.VerificationCode}</p></Col>
                            </Row>
                            <Row className='justify-content-center border-top my-3'>
                                <Col className="my-3"><p className="famsa-text-blue fw-bold"><FormattedMessage id="step.four.amount.paid" />:</p></Col>
                                <Col className="text-end my-3"><p className="famsa-text-blue fw-bold">{currencyFormatter({ currency: "USD", value: (amount + ((type_pay === 2) ? parseFloat(FAMSA.SERVER.TRANSACTION) : 0)) })}</p></Col>
                            </Row>
                        </Col>
                    </Row>
                    {(type_pay === 1) ?
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <FloatingLabel
                                    controlId="floatingInput"
                                    label={intl.formatMessage({ id: "step.two.label.email" })}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="email"
                                        value={Email}
                                        placeholder={intl.formatMessage({ id: "step.two.label.email" })}
                                        onChange={(e) => handEmail(e, e.target.value)}
                                        isInvalid={invalid.email}
                                        isValid={validated.email} />
                                </FloatingLabel>
                            </Form.Group>
                        </Form>
                        </Col>
                    </Row>
                    : null}
                    {(type_pay === 1) ?
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                            <Button className="btn text-white famsa-btn-blue-four famsa-btn-w" onClick={handleSendEmail} disabled={loadingMail}>
                                {(loadingMail) ?
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> Loading...</>
                                    : <><Envelope className="me-3" /><FormattedMessage id="step.four.send" /></>}
                            </Button>
                        </Col>
                    </Row>
                    : null}
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                            <Button className="btn text-white famsa-btn-green famsa-btn-w" onClick={handleLinkDownloand} disabled={loading}>
                                {(loading) ?
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        /> Loading...</>
                                    : <><CheckLg className="me-3" /><FormattedMessage id="step.four.downloand" /></>}
                            </Button>
                        </Col>
                    </Row>
                    {(type_pay === 1) ?
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                            <Button className="btn text-white famsa-btn-blue-four famsa-btn-w" onClick={handleotherpayment}>
                                <SkipBackwardCircle className="me-3" /><FormattedMessage id="step.four.other" />
                            </Button>
                        </Col>
                    </Row>
                    : null}
                    {(type_pay === 1) ?
                    <Row className='justify-content-center mx-1 my-3'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                            <Button className="btn text-white famsa-btn-gray famsa-btn-w" onClick={() => window.open(url, '_self')}>
                                <BoxArrowLeft className="me-3" /><FormattedMessage id="step.four.finish" />
                            </Button>
                        </Col>
                    </Row>
                    : null}
                    <Row hidden className='justify-content-center mx-1 my-1'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                            <Button className="btn text-white famsa-btn-blue-four famsa-btn-w" href="https://locations.famsafurniture.com/deals/" target="_blank">
                                <FormattedMessage id="step.four.highly.check" />
                            </Button>
                        </Col>
                    </Row>
                    <Row  hidden className='justify-content-center mx-1 my-1'>
                        <Col md={{ span: 5 }} sm={{ span: 8 }} >
                            <Button className="btn text-white famsa-btn-blue-four famsa-btn-w" href="https://locations.famsafurniture.com" target="_blank">
                                <FormattedMessage id="step.four.highly.find" />
                            </Button>
                        </Col>
                    </Row>
                </>
            }
        </>
    );
}

export default StepFour;